import type { AdSlot } from '@ad-engine/core';

export interface DsaData {
	behalf: string;
	paid: string;
	slot: AdSlot;
}

export function dsaDataAvailable(bid: PrebidBidResponse): boolean {
	return typeof bid.meta?.dsa?.behalf === 'string' && typeof bid.meta?.dsa?.adrender === 'number';
}

export function prepareDsaData(bid: PrebidBidResponse, slot: AdSlot): DsaData {
	const behalf = bid.meta?.dsa?.behalf as string;

	return {
		behalf: behalf,
		paid: bid.meta?.dsa?.paid ?? behalf,
		slot,
	};
}
